import angular from 'angular';
import _ from 'lodash';

export default angular.module('reportSubscriptionsErrorCodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      reportSubscriptions: {
        29: () => ({ title: gettextCatalog.getString('Subscription already exists.') }),
      },
      sftp: {
        RETAILER_NOT_FOUND: () => ({ title: gettextCatalog.getString('Retailer not found.') }),
        SFTP_CONFIGURATION_ALREADY_EXISTS: () => ({ title: gettextCatalog.getString('SFTP Configuration for selected Retailer already exists.') }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/config/errorcodes.conf.js